export const FORM_ITEM_QUESTION_NAMESPACE = "answers";

// By default we should include the TimeZone when we send a Date to the server.
// This will allow more flexibility if we need do some computation with dates
// Form more info on DATE format and how .NET will parse dates check:
// https://en.wikipedia.org/wiki/ISO_8601
// https://docs.microsoft.com/en-us/dotnet/standard/datetime/system-text-json-support
export const ISO_8601_DATE_FORMAT = "YYYY-MMM-DDTHH:mm:ssZ";
export const DEFAULT_DATE_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";